import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { TZTest1SampCard, Variable } from 'src/generated-sources';
import { FormBuilder, Validators } from '@angular/forms';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { CardWizardVariable } from '@features/eda/card-models';
import { Observable } from 'rxjs';
import { CardWizardService } from '../../../card-wizard/card-wizard.service';

@UntilDestroy()
@Component({
  selector: 'tztest1-samp-card-config',
  templateUrl: './tztest1-samp-card-config.component.html',
  styleUrls: ['./tztest1-samp-card-config.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TZTest1SampCardConfigComponent implements OnInit, OnChanges, OnDestroy {
    @Input() params: TZTest1SampCard;
    @Output() paramsChange = new EventEmitter<TZTest1SampCard>(true);
    @Output() validityChange = new EventEmitter<boolean>(true);

    allVariables$: Observable<CardWizardVariable[]>;

    configForm = this.fb.group({
        hypothesizedMean: this.fb.control(null, [Validators.required]),
        column: this.fb.control(null, [Validators.required])
    });

    constructor(
        private fb: FormBuilder,
        private cardWizardService: CardWizardService
    ) {
        this.configForm.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe((formValue) => this.paramsChange.emit({
                ...this.params,
                column: formValue.column,
                hypothesizedMean: formValue.hypothesizedMean
            }));

        this.configForm.statusChanges
            .pipe(untilDestroyed(this))
            .subscribe(() => this.validityChange.emit(this.configForm.valid));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.params) {
            this.configForm.patchValue({
                hypothesizedMean: this.params.hypothesizedMean,
                column: this.params.column
            });
        }
    }

    ngOnInit() {
        this.allVariables$ = this.cardWizardService.availableVariables(this.params.type);
    }

    ngOnDestroy() {

    }
}
